const CHAT_CREATED="CHAT_CREATED"
const NEW_MESSAGE="NEW_MESSAGE"
const JOIN_CHAT="JOIN_CHAT"
const RECEIVE_MESSAGE="RECEIVE_MESSAGE"
const AUTOMATIC_MESSAGE="AUTOMATIC_MESSAGE"
const UPDATE_CHAT="UPDATE_CHAT"
const MARK_READ="MARK_READ"

export {CHAT_CREATED, NEW_MESSAGE, JOIN_CHAT, RECEIVE_MESSAGE, AUTOMATIC_MESSAGE, UPDATE_CHAT, MARK_READ}